import BaseModel from './BaseModel';
export default class ConfigPHS extends BaseModel {
    constructor(data = {}) {
        super(data);
        this.setData(data)
    }

    setData(data = this.__data__) {
        this.id = data.id || undefined;
        this.isSuccess = data.isSuccess || false;
        this.errors = data.errors || undefined;
        this.sessionLiveTime = data.sessionLiveTime || 0;
        this.paymentTime = data.paymentTime || 0;
        this.isActive = data.isActive || false;
        this.countOfReset = data.countOfReset || 0;
        this.type = data.type || 'Hotel'
    }

    export(hasTranslate = false) {
        const result = super.export({
            id: this.id,
            sessionLiveTime: this.sessionLiveTime,
            paymentTime: this.paymentTime,
            isActive: this.isActive || false,
            countOfReset: this.countOfReset,
            type: this.type
        });
        return result;
    }

}